module.exports = __webpack_public_path__ + "img/nampawa-mechaniczna.71bc5906.jpg";